import { Uuid } from '~src/utils/UUID';
import { z } from 'zod';
import { UserRole } from '~/src/types';

export const GroupMember = z.object({
  user_id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
  group_id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
  alias: z.string(),
  user_role: UserRole,
  profile_image: z.string().nullable(),
});
export type GroupMember = z.infer<typeof GroupMember>;

export const GroupMemberArray = z.array(GroupMember);
export type GroupMemberArray = z.infer<typeof GroupMemberArray>;

export const Group = z.object({
  id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
  display_name: z.string(),
  user_role: UserRole,
  user_alias: z.string(),
  group_image: z.string().nullable(),
  user_profile_image: z.string().nullable(),
});
export type Group = z.infer<typeof Group>;
export const GroupArray = z.array(Group);
export type GroupArray = z.infer<typeof GroupArray>;

export const CreateGroupResponse = z.object({
  group_id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
});
export type CreateGroupResponse = z.infer<typeof CreateGroupResponse>;
